// These are classes that can get applied globally to elements (usually the <body />)
// that allow globally styling in certain circumstances.

// Usually this kind of power isn't needed, so use this sparingly
export const BODY_NO_SCROLL = 'no-scrolling'
export const LOCKED_SEARCH = 'search-v2-locked'
